// import external dependencies
// jquery
import 'jquery';
import 'hammerjs';
import 'jquery-hammerjs';
// vue
import Vue from 'vue';
import inViewportDirective from 'vue-in-viewport-directive';

// Import everything from autoload
import "./autoload/_bootstrap.js";

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
    // All pages
    common,
    // Home page
    home,
    // About Us page, note the change from about-us to aboutUs.
    aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// Vue-Directives
Vue.directive('in-viewport', inViewportDirective);
Vue.use(inViewportDirective);

// Vue-Componentsf
Vue.component('portfolio-archive', require('./vue/archive-portfolio.vue').default);
Vue.component('home-slider', require('./vue/home-slider.vue').default);
Vue.component('lazy-image', require('./vue/lazy-image.vue').default);
Vue.component('mapbox', require('./vue/map-box.vue').default);
Vue.component('portfolio-single', require('./vue/single-portfolio.vue').default);

new Vue({
    el: '#app',
});



// WEBPACK FOOTER //
// ./scripts/main.js